import { TableField } from "@/types/table-field";

const numeroNormativo: TableField = {
    key: "numeroNormativo",
    label: "Número",
    tdClass: ["align-middle", "quebrarPorPalavraHard"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: true,
};
const anoNormativo: TableField = {
    key: "anoNormativo",
    label: "Ano",
    tdClass: ["align-middle", "naoQuebrar"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: true,
};
const veiculoNormativo: TableField = {
    key: "veiculoNormativo",
    label: "Veículo de Publicação",
    tdClass: ["align-middle", "naoQuebrar"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: true,
};
const tipoNormativo: TableField = {
    key: "tipoNormativo",
    label: "Tipo",
    tdClass: ["align-middle", "naoQuebrar"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: true,
};
const dtInicioVigenciaNormativo: TableField = {
    key: "dtInicioVigenciaNormativo",
    label: "Início de vigência",
    tdClass: ["align-middle", "naoQuebrar"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: true,
};
const actions = {
    key: "actions",
    label: "Ações",
    tdClass: ["align-middle", "col-actions"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: false,
};

export const fieldsNormativoAdicionado: TableField[] = [
    numeroNormativo,
    anoNormativo,
    veiculoNormativo,
    tipoNormativo,
    dtInicioVigenciaNormativo,
    actions
];